// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"0ea3d979","692":"2b99e81a"}[chunkId] + ".chunk.js";
};